import {SearchFilterRequest} from "./search-table.dto.req";
import {FormSelectOption} from "../../../libs/form/items/form-select-option";
import {nonBlank} from "../../../libs/utils/epic.utils";

export interface SearchItem {

  readonly id: string;

  readonly [x: string]: any;

  isEditable(): boolean;
}

export class SearchResultDto {

  public readonly query: string | undefined;
  public readonly items!: SearchItem[];
  public readonly hits!: number;
  public readonly page!: number;
  public readonly pageSize!: number;
  public readonly from!: number;
  public readonly sortField!: string;
  public readonly sortOrder!: 'asc' | 'desc';
  public filters: SearchFilterResponse[] = [];

  constructor(init?: Partial<SearchResultDto>) {
    if (init?.filters) {
      this.filters = init.filters.map((f) => new SearchFilterResponse(f));
      delete init.filters;
    }
    Object.assign(this, init);
  }
}

export class SearchFilterResponse extends SearchFilterRequest {

  public values: SearchFilterValueResponse[] = [];

  constructor(init?: Partial<SearchFilterResponse>) {
    super(init);
    if (init?.values) {
      this.values = init.values.map((v) => new SearchFilterValueResponse(v));
      delete init.values;
    }
    Object.assign(this, init);
  }

  public buildSelectOption(): FormSelectOption[] {
    return this.values
      .filter((v) => v.hasValues())
      .map((v) => new FormSelectOption(v.name, v.getIdOrName()).useName());
  }
}

export class SearchFilterValueResponse {

  public readonly id?: string;
  public readonly name!: string;
  public readonly count!: number;

  constructor(init?: Partial<SearchFilterValueResponse>) {
    Object.assign(this, init);
  }

  public getIdOrName(): string {
    return this.id ? this.id : this.name;
  }

  public hasValues(): boolean {
    return nonBlank(this.id) && nonBlank(this.name);
  }
}
